import { useVTApiClient } from './client'
import { useApiKey } from './useApiKey'
import { useQuery, useQueries } from '@maui/react-query'

export const useUserDetails = ({ userId }, options = {}) => {
  const api = useVTApiClient('auth')
  const { data: apiKey } = useApiKey()
  const ready = !!(userId && apiKey)

  return useQuery({
    queryFn: () => api.userDetails({ userId, apiKey }),
    queryKey: ['userDetails', userId, apiKey],
    select: ({ data }) => data,
    ...options,
    enabled: options.enabled !== false && ready,
  })
}

export const useUserDetailsQueries = ({ ids }, options = {}) => {
  const api = useVTApiClient('auth')
  const { data: apiKey } = useApiKey()
  const ready = !!(ids && apiKey)
  return useQueries({
    queries: ids.map((userId) => {
      return {
        queryFn: () => api.userDetails({ userId, apiKey }),
        queryKey: ['userDetails', userId, apiKey],
        select: ({ data }) => {
          const { attributes } = data
          const { first_name: firstName, last_name: lastName } = attributes
          data.fullName = `${firstName} ${lastName}`
          data.userId = userId
          return data
        },
        ...options,
        enabled: options.enabled !== false && userId && ready,
      }
    }),
  })
}
